import type {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'
import {config} from '@cart/src/config/config'

@Injectable({providedIn: 'root'})
export class AddCustomHeadersInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestAuth = req.clone({
      setHeaders: {
        appId: config.appId,
        'X-AppId': config.appId,
        'X-Uve-Platform': 'eComm',
      },
    })
    if (!req.headers.has('Content-Type') && (!req.body || (req.body instanceof FormData && !req.body.has('file')))) {
      requestAuth.headers.append('Content-Type', `application/json`)
    }
    if (!req.headers.has('Timeout')) {
      requestAuth.headers.append('Timeout', `20`)
    }

    return next.handle(requestAuth)
  }
}
